// ==============================|| VIEWS - PAGES - SCHEDULE INSPECTION - ACTION ||============================== //

import { ScheduleInspectionDTO } from "../../../common/types/common.dto.types";

export const GETSCHEDULEINSPECTIONINITIALDATA =
  "GETSCHEDULEINSPECTIONINITIALDATA";

export const SAVESCHEDULEINSPECTION = "SAVESCHEDULEINSPECTION";
export const SCHEDULEINSPECTIONNAVIGATION = "SCHEDULEINSPECTIONNAVIGATION";
export const SCHEDULEINSPECTIONCONFIRMATION = "SCHEDULEINSPECTIONCONFIRMATION";

export const getScheduleInspectionInitialData = (inspectionSetId: number) => {
  return { type: GETSCHEDULEINSPECTIONINITIALDATA, payload: inspectionSetId };
};

export const saveScheduleInspection = (
  scheduleInspection: ScheduleInspectionDTO
) => {
  return { type: SAVESCHEDULEINSPECTION, payload: scheduleInspection };
};

export const scheduleInspectionNavigate = () => {
  return {
    type: SCHEDULEINSPECTIONNAVIGATION,
  };
};

export const scheduleInspectionConfirmation = (
  scheduleInspection: ScheduleInspectionDTO,
  onConfirmationCallBack: (scheduleInspection: ScheduleInspectionDTO) => void
) => {
  return {
    type: SCHEDULEINSPECTIONCONFIRMATION,
    payload: {
      scheduleInspection: scheduleInspection,
      onConfirmationCallBack: onConfirmationCallBack,
    },
  };
};
